<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          :class="['question-tital-name ml-2', isFieldDisabled ? 'disable-question' : '', isRTLlang(lang) ? 'question-heading-child' : '']"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="text-warning pl-5 fw-bold pt-10" v-if="hasFieldWarning">{{ fieldWarningText }}</span>
        <span
          class="text-danger pl-15 fw-bold"
          v-if="componentData && !componentData.isSkippable && componentData.optionsIds && !componentData.optionsIds.length && sendMultiChoiceData.showValidationMessage && !isFieldDisabled"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
        >
          This field is required.
        </span>

        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }" v-if="componentData.isSkippable">Optional</span>
        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
      </b-col>
    </b-row>
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row class="pt-10 pl-40 pb-10" v-if="componentData.hasBodyImage">
        <b-col cols="12" class="d-flex">
          <div class v-for="(img, index) in componentData.bodyImages" :key="index">
            <img :src="img.imageUrl" alt class="wid300" />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-40 pt-10">
        <b-form-group v-if="componentData.subType === 'Single'">
          <b-form-radio-group name="activityFormBooleanPreview" stacked disabled>
            <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group v-if="componentData.subType === 'Multi'">
          <b-form-checkbox-group name="activityFormBooleanPreview" stacked disabled>
            <b-form-checkbox v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-col cols="8"></b-col>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pt-10 pl-40 pb-10" v-if="componentData.hasBodyImage" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="12" class="d-flex">
          <div class v-for="(img, i) in componentData.bodyImages" :key="i">
            <img :src="img.imageUrl" alt class="wid300" />
          </div>
        </b-col>
      </b-row>
      <b-row class="pl-50" v-if="componentData.optionsIds" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-form-group class="mb-5" v-if="componentData.subType === 'Single' || componentData.subType === undefined">
          <b-form-radio-group v-bind:class="isRTLlang(lang) ? 'rtl radio-position-inline' : ''" v-model="componentData.optionsIds[0]" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" stacked :disabled="isFieldDisabled" v-on:change="onChangeOptions($event)">
            <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id">
              <div class="ap-thread-alert-message-preview radio-mrgn-5">
                <span
                  v-translate:_formattedBody="{
                    key: translationKeyInitial,
                    val: lang,
                    optionId: option.id,
                    optionLable: '_options_',
                    html: option.formattedBody
                  }"
                  v-html="option.formattedBody"
                ></span>
                <AlertMessage v-if="componentData.colorCodeEnabled && componentData.optionsIds[0] === option.id" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
              </div>
            </b-form-radio>
          </b-form-radio-group>
          <div v-if="isRTLlang(lang)" class="float-right">
            <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
                <span v-else>{{ componentData.actualScore }}</span>
              </div>
            </div>
          </div>
        </b-form-group>

        <b-form-group class="mb-5" v-if="componentData.subType === 'Multi'">
          <b-form-checkbox-group v-bind:class="isRTLlang(lang) ? 'rtl radio-position-inline' : ''" v-model="componentData.optionsIds" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" stacked :name="`multiChoice-${componentData.id}`" :disabled="isFieldDisabled" v-on:change="onChangeMultiOptions($event)">
            <b-form-checkbox v-for="option in componentData.options" :key="option.id" :value="option.id" :disabled="disableCheckBox && noneOptionId != option.id">
              <div class="ap-thread-alert-message-preview radio-mrgn-5">
                <span
                  v-translate:_formattedBody="{
                    key: translationKeyInitial,
                    val: lang,
                    optionId: option.id,
                    optionLable: '_options_',
                    html: option.formattedBody
                  }"
                  v-html="option.formattedBody"
                ></span>
                <div
                  :style="{
                    marginBottom: componentData.colorCodeEnabled && option.colorCoding && option.colorCoding.color ? '10px' : ''
                  }"
                  v-for="(id, index) in componentData.optionsIds"
                  :key="index"
                >
                  <div v-if="componentData.colorCodeEnabled && id === option.id">
                    <AlertMessage :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
                  </div>
                </div>
              </div>
            </b-form-checkbox>
          </b-form-checkbox-group>
          <div v-if="isRTLlang(lang)" class="float-right">
            <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
                <span v-else>{{ componentData.actualScore }}</span>
              </div>
            </div>
          </div>
        </b-form-group>

        <b-col cols="8"></b-col>
      </b-row>
      <div v-if="lang != 'he' && lang != 'ar-IL'" :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
            <span v-else>{{ componentData.actualScore }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>

          <div v-if="componentData.subType === 'Multi'">
            <div v-for="(option, index) in componentData.options" :key="index">
              <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '', { 'ap-multiple-choice-answer': option.id === answerId }]" v-for="(answerId, index) in componentData.optionsIds" :key="index">
                <div v-if="option.id === answerId" class="ap-multichoice-option-answer">
                  <span
                    v-translate:_formattedBody="{
                      key: translationKeyInitial,
                      val: lang,
                      optionId: option.id,
                      optionLable: '_options_',
                      html: option.formattedBody || option.body
                    }"
                    v-html="option.formattedBody || option.body"
                  >
                  </span>
                  <AlertMessage v-if="componentData.colorCodeEnabled && componentData.answer" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
                </div>
              </div>
            </div>
          </div>
          <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '', 'ap-multiple-choice-answer']" v-if="componentData.subType === 'Single'">
            <span
              v-if="!!componentData.optionsIds && componentData.optionsIds.length > 0"
              v-translate:_formattedBody="{
                key: translationKeyInitial,
                val: lang,
                optionId: componentData.optionsIds[0],
                optionLable: '_options_',
                html: componentData.answer
              }"
              v-html="componentData.answer"
            />
            <span v-else>{{ componentData.answer }}</span>
            <div>
              <div v-for="(option, index) in componentData.options" :key="index">
                <AlertMessage v-if="componentData.colorCodeEnabled && componentData.answer === option.formattedBody" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
              </div>
            </div>
          </div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousOptionsIds">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import AlertMessage from "../../common/alert-message";
import langTranslate from "./lang-translate";
import _ from "lodash";

export default {
  name: "activity-form-multi-choice-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      scoresMap: {},
      noneOptionId: "",
      disableCheckBox: false
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    showValidationMessage: {
      type: Boolean,
      default: false
    },
    sendMultiChoiceData: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ""
    },
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    lang: String
  },
  components: {
    AlertMessage
  },
  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.$validator.validateAll();
      }
    },
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && this.componentData.optionsIds.length > 0 && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    componentData() {
      const noneOption = _.find(this.componentData.options, function(o) {
        return o.formattedBody.toLowerCase() == "none";
      });
      if (noneOption) {
        this.noneOptionId = noneOption.id;
      }
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const otherOption = this.componentData.options.find(option => {
          return option.id === this.componentData.otherOptionId;
        });
        if (!otherOption && this.mode == 2) {
          this.insertOtherOption();
        }
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  mounted() {
    try {
      this.calculateScoresMap();
    } catch (e) {}
    if (this.mode == 1) {
      this.insertOtherOption();
      this.calculateScoresMap();
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const otherOption = this.componentData.options.find(option => {
          return option.id === this.componentData.otherOptionId;
        });
        if (!otherOption) {
          this.insertOtherOption();
        }
      }
      if (!this.componentData.optionsIds) {
        this.componentData.optionsIds = [];
      }
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
    this.componentData.options = this.getUniqueOptionsById(this.componentData.options, "id");
  },
  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    isScoreExcluded(answer) {
      let excludeScore = false;
      const option = this.componentData.options.find(option => option.body == answer);
      if (option) {
        excludeScore = option.excludeScore;
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.optionsIds = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.dataChecks = [];
      this.hasFieldError = false;
      this.hasFieldWarning = false;
      this.sendMultiChoiceData.showValidationMessage = false;
      this.errors.clear();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.disableCheckBox = false;
      this.resetField();
      this.componentData.dataChecks = [];
      this.$emit("onClearAnswer", this.componentData);
    },
    onChangeOptions(e) {
      if (e == this.componentData.otherOptionId && this.componentData.otherCommentSelectedField && this.mode == 1) {
        this.$toastr.success(this.componentData.otherCommentSelectedField);
      }
      this.componentData.dataChecks = [];
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
      this.$emit("onValidateAnswer", this.sendMultiChoiceData);
      this.onAnswerChange();
    },
    onChangeMultiOptions(optionIdsOld) {
      let optionIds = optionIdsOld;
      this.disableCheckBox = false;
      if (optionIds.includes(this.noneOptionId)) {
        optionIds = [];
        this.componentData.optionsIds = [];
        optionIds.push(this.noneOptionId);
        this.componentData.optionsIds.push(this.noneOptionId);
        this.disableCheckBox = true;
      }
      if (optionIds instanceof Array) {
        if (optionIds.includes(this.componentData.otherOptionId) && this.componentData.otherCommentSelectedField && this.mode == 1) {
          this.$toastr.success(this.componentData.otherCommentSelectedField);
        }
        this.componentData.computedScore = 0;
        this.componentData.actualScore = 0;
        optionIds.forEach(id => {
          for (const score in this.scoresMap) {
            if (score == id) {
              this.componentData.computedScore += this.scoresMap[score];
              this.componentData.actualScore += this.scoresMap[score];
            }
          }
        });
      } else {
        this.componentData.computedScore = this.scoresMap[optionIds];
        this.componentData.actualScore = this.scoresMap[optionIds];
      }
      this.onAnswerChange();
      this.$forceUpdate();
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const sequence = this.componentData.options.length + 1;
        this.componentData.options.push({
          body: this.componentData.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.componentData.otherOptionContentField,
          id: this.componentData.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          score: this.componentData.otherScore,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    getUniqueOptionsById(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.component-div:hover .icons-div {
  display: block;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}
.ap-multiple-choice-answer {
  margin: 2px 0px 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .ap-multichoice-option-answer {
    display: flex;
  }
}
.ap-thread-alert-message-preview {
  display: flex;
  flex-wrap: wrap;

  span p {
    margin-bottom: 0px !important;
  }
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.wid300 {
  max-width: 300px !important;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
/deep/ .custom-control-label {
  white-space: normal !important;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
